export const paymentRedirect = `
    We will be redirecting you to a secure gateway(flutter wave) to complete your payment.
    Click continue to proceed.
`;

export const bookLiveCourseInfo = `
    You are about to book a live course. The tutor has to accept your booking before you can be enrolled.
    Click continue to book this course.
`;
